import React, { useLayoutEffect, useState } from "react";
import Header from "./common/header";
import Footer from "./common/footer";
import { Outlet, useLocation } from "react-router";
import { isDeviceMobile } from "../helpers/deviceDetect";
import MobileOnly from "../pages/simple/mobile-only";
import routeNames from "../constants/routeNames";

const desktopAvailableRoutes = [routeNames.TERMS];

export default function Layout() {
  const isMobile = isDeviceMobile(navigator.userAgent);
  const { pathname } = useLocation();
  const [showFooterImage, setShowFooterImage] = useState(true);

  useLayoutEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  return (
    <main>
      <Header />
      <section>
        {isMobile || desktopAvailableRoutes.includes(pathname) ? (
          <Outlet context={{ setShowFooterImage }} />
        ) : (
          <MobileOnly />
        )}
      </section>
      <Footer withFooterImage={showFooterImage} />
    </main>
  );
}
